import { render } from "./create_edit.vue?vue&type=template&id=ce2ec892&scoped=true"
import script from "./create_edit.vue?vue&type=script&lang=js"
export * from "./create_edit.vue?vue&type=script&lang=js"

import "./create_edit.vue?vue&type=style&index=0&id=ce2ec892&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ce2ec892"

export default script